import { observer } from 'mobx-react-lite';
import { FC } from 'react';

import { IcUpdateIcon } from '@gem/icons';
import { IconButton } from '@gem/ui-kit';

import { Group } from 'APP/store/Groups/Group';

import { useGroupUpdateLinkButtonPresenter } from './presenter/GroupUpdateLinkButton.presenter';

interface IGroupUpdateLinkButtonParams {
  group: Group;
}

export const GroupUpdateLinkButton: FC = observer(({ group }: IGroupUpdateLinkButtonParams) => {
  const presenter = useGroupUpdateLinkButtonPresenter({ group });

  if (!presenter.isAvailableUpdateDeepLinkHash) {
    return null;
  }

  return (
    <IconButton
      Icon={IcUpdateIcon}
      onClick={presenter.onUpdateDeepLink}
    />
  );
});
